// extracted by mini-css-extract-plugin
export default {"wrapper":"SystemSettings_wrapper__CZmn0","settingsContentContainer":"SystemSettings_settingsContentContainer__Bj5KP","content":"SystemSettings_content__MxsbC"};